import { render, staticRenderFns } from "./cefloreco-text-gradient.vue?vue&type=template&id=c0d9d3c0&scoped=true&"
import script from "./cefloreco-text-gradient.vue?vue&type=script&lang=js&"
export * from "./cefloreco-text-gradient.vue?vue&type=script&lang=js&"
import style0 from "./cefloreco-text-gradient.vue?vue&type=style&index=0&id=c0d9d3c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d9d3c0",
  null
  
)

export default component.exports